import {observer} from "mobx-react";
import {useStore} from "../../stores/Store";
import {List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography, useTheme} from "@mui/material";
import React from "react";
import HomeIcon from '@mui/icons-material/Home';
import ApartmentIcon from '@mui/icons-material/Apartment';
import QueueMusicSharpIcon from '@mui/icons-material/QueueMusicSharp';
import PermContactCalendarSharpIcon from '@mui/icons-material/PermContactCalendarSharp';
import GroupIcon from '@mui/icons-material/Group'
import {useLocation, useNavigate} from "react-router-dom";
import LanguageChanger from "../LanguageChanger/LanguageChanger";
import LogoutIcon from '@mui/icons-material/Logout';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

interface NavBarProps {
    mobile: boolean
    clickCallback?: () => void
}

const desktopListStyle = {
    display: 'flex', flexDirection: 'row', justifyContent: 'center'
}

const mobileListStyle = {

}

export default observer(function NavBar({mobile=false, clickCallback=()=>{}}: NavBarProps){
    const {LanguageStore: {currentLanguageMessages: clm}, UserStore} = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const activeColor = 'secondary'
    const activeStyle = {
        color: theme.palette.secondary.main,
        borderBottom: '1px solid ' + theme.palette.secondary.light,
    }

    const onMenuItemClick = (link: string) => {
        navigate(link);
        clickCallback()
    }

    const isActive = (link: string): boolean => {
        if(link === '/') return location.pathname === link;
        return location.pathname.includes(link)
    }

    return (
            <List sx={(mobile) ? mobileListStyle : desktopListStyle} >
                <ListItem key={'navbar-NewsListItem'} >
                    <ListItemButton onClick={() => onMenuItemClick('/')} >
                        <ListItemAvatar>
                            <HomeIcon
                                color={(isActive('/')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/')) ? activeStyle : undefined}>
                                {clm.NavBar.HomeTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                <ListItem key={'navbar-AccordionsListItem'} >
                    <ListItemButton onClick={() => onMenuItemClick('/Accordions')}>
                        <ListItemAvatar>
                            <QueueMusicSharpIcon
                                color={(isActive('/Accordions')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/Accordions')) ? activeStyle : undefined}>
                                {clm.NavBar.AccordionsTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                <ListItem key={'navbar-AccessoriesListItem'}>
                    <ListItemButton onClick={() => onMenuItemClick('/Accessories')}>
                        <ListItemAvatar>
                            <LocalOfferIcon
                                color={(isActive('/Accessories')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/Accessories')) ? activeStyle : undefined}>
                                {clm.NavBar.AccessoriesTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                <ListItem key={'navbar-ContactsListItem'} >
                    <ListItemButton onClick={() => onMenuItemClick('/Contact')}>
                        <ListItemAvatar>
                            <PermContactCalendarSharpIcon
                                color={(isActive('/Contact')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/Contact')) ? activeStyle : undefined}>
                                {clm.NavBar.ContactTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                <ListItem key={'navbar-TeamListItem'} >
                    <ListItemButton onClick={() => onMenuItemClick('/Team')}>
                        <ListItemAvatar>
                            <GroupIcon
                                color={(isActive('/Team')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/Team')) ? activeStyle : undefined}>
                                {clm.NavBar.TeamTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                <ListItem key={'navbar-CompanyListItem'} >
                    <ListItemButton onClick={() => onMenuItemClick('/Company')}>
                        <ListItemAvatar>
                            <ApartmentIcon
                                color={(isActive('/Company')) ? activeColor : undefined}
                            />
                        </ListItemAvatar>
                        <ListItemText>
                            <Typography sx={(isActive('/Company')) ? activeStyle : undefined}>
                                {clm.NavBar.CompanyTitle}
                            </Typography>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
                {
                    UserStore.isLoggedIn &&
                    <ListItem key={'logout'} sx={{justifyContent: 'center'}}>
                        <ListItemButton onClick={() => UserStore.logout()}>
                            <ListItemAvatar><LogoutIcon /></ListItemAvatar>
                            <ListItemText>{clm.NavBar.LogoutTitle}</ListItemText>
                        </ListItemButton>
                    </ListItem>
                }
                <ListItem key={'navbar-LanguageChanger'} sx={{justifyContent: 'center'}} >
                    <LanguageChanger />
                </ListItem>
            </List>
    )
})